module.exports = __webpack_public_path__ + "img/header-weddingRingsClassic.d754171.jpg";